export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_check') || '返答审核',
    icon: 'el-icon-s-check',
    menuType: 'check',
    divided: true,
    allow: 'R',
  },
  {
    text: that.$l('menu_text_confirm') || '确认返答',
    icon: 'el-icon-check',
    menuType: 'confirm',
    allow: 'C',
  },
  {
    text: that.$l('menu_text_cancel') || '取消补货',
    icon: 'el-icon-close',
    menuType: 'cancel',
    divided: true,
    allow: 'B',
  },
]
